// Need to use the React-specific entry point to import createApi

import { baseApi } from "../../Data/services/baseApi";

// using CSRF token from Redux Store

// Define a service using a base URL and expected endpoints
export const profileApi = baseApi.injectEndpoints({
  // reducerPath: "profileApi",

  // mode: "no-cors",
  credentials: "include",
  endpoints: (builder) => ({
    getMyProfile: builder.query({
      query: () => ({
        url: "/",
        method: "GET",
      }),
      // transformResponse: (response) => response.data, // Adjust based on your actual API response structure
    }),
    changePassword: builder.mutation({
      query: (user) => {
        return {
          url: "change-password",
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    updataProile: builder.mutation({
      query: (user) => {
        return {
          url: "",
          method: "PATCH",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetMyProfileQuery,
  useChangePasswordMutation,
  useUpdataProileMutation,
} = profileApi;
